module.exports = __webpack_public_path__ + "img/2 (7).49b4fd91.jpg";